import { RequestEnvelope } from "@cur8/api-client/dist/api/types";
import { useQuery } from "@tanstack/react-query";
import { useAPIClient } from "render/context/APIContext";

function applySignal<T>(req: RequestEnvelope<T>, signal: AbortSignal) {
  signal.addEventListener("abort", () => req.abandon());
}

export function useECGDeviceQuery(pointer: {
  patientId: string;
  visitId: string;
}) {
  const api = useAPIClient();
  return useQuery({
    queryKey: ["ecg", pointer.patientId, pointer.visitId],
    queryFn: ({ signal }) => {
      const getDeviceReq = api.ecg.getDevice(pointer);
      applySignal(getDeviceReq, signal);

      return getDeviceReq.result;
    },
  });
}
